import { useCallback, useState } from 'react';
import { StoresTabQueryParam } from '@/presentation/services/urls';

export function useStoreTabHandler(initialTab: StoresTabQueryParam) {
  const [tab, setTab] = useState<StoresTabQueryParam>(() => initialTab);

  const updateTab = useCallback((newTab: StoresTabQueryParam) => {
    setTab(newTab);
  }, []);

  return { tab, updateTab };
}
